export default __webpack_public_path__ + "static/media/190629_190332_IMG_E5733.ebb9fc64.jpg";